const DEFAULT_ROOT_DOMAIN = 'fieldhouse.club';
const RESERVED_APP_SUBDOMAINS = new Set(['api', 'app', 'www']);

export function getPublicOrganizationSlug(locationLike = window.location) {
  const search = new URLSearchParams(locationLike.search || '');
  const previewSlug = search.get('org');
  if (previewSlug) return previewSlug.trim().toLowerCase();

  const hostname = String(locationLike.hostname || '').toLowerCase();
  const rootDomain = String(
    process.env.REACT_APP_PUBLIC_SITE_ROOT_DOMAIN || DEFAULT_ROOT_DOMAIN
  ).toLowerCase();

  if (!hostname.endsWith(`.${rootDomain}`)) return null;

  const prefix = hostname.slice(0, -(rootDomain.length + 1));
  if (!prefix || prefix.includes('.') || RESERVED_APP_SUBDOMAINS.has(prefix)) return null;
  return prefix;
}
